var map = {
	"./h1.jpg": "lojV",
	"./h10.jpg": "rxOq",
	"./h11.jpg": "ltwe",
	"./h12.jpg": "buVD",
	"./h2.jpg": "YTg1",
	"./h3.jpg": "+A6G",
	"./h4.jpg": "pj53",
	"./h5.jpg": "CF5V",
	"./h6.jpg": "c2JK",
	"./h7.jpg": "ZG7P",
	"./h8.jpg": "UkwA",
	"./h9.jpg": "eiMS",
	"./sign.jpg": "mfZc",
	"./staff-kids.jpg": "qL50"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JeQr";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Hridya/Hridya-pics ^\.\/.*$
// module id = JeQr
// module chunks = 0